/*******************************************************************************
Chemical Actions: All interactions in the chemical component

*******************************************************************************/
import { FETCH_CHEMICALS, SELECT_CHEMICAL, SELECT_CHEMICAL_TO_EDIT,
  ERROR, CLEAR_FORM, EMAIL_FILE } from './types';
import { ROOT_URL } from '../../constants';
import { fillForm, resetForm, handleRecommendedDosage,
  handleMaxQuantity } from '../cult_utils';
import axios from 'axios';
const $ = window.$;

const Materialize = window.Materialize;
/**
* fetchChemicals(): Fetches all chemicals
* @returns {Array} chemicals
* @called-in: ['/components/chemical/chemical_view.js']
**/
export function fetchChemicals() {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchChemicals`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        dispatch({ type: FETCH_CHEMICALS, payload: res.data.chemicals });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching chemicals.`));
      });
  }
}
/**
* createChemical(): Submits a new chemical
* @param {Array} formData: All form data
* @returns {Object} Newly created chemical
* @called-in: ['/components/chemical/chemical_view']
**/
export function createOrEditChemical(data, eid, type, path, editedChemical={}) {
  // Form validation check
  for (let key in data) {
    if (key === 'name' && data[key] === '') return error('Product Name is Required');
    if (key === 'ingredients' && data[key] === '') return error('Ingredients are Required');
    if (key === 'type' && data[key] === '') return error('Product Type is Required');
    if (key === 'epaNo' && data[key] === '') return error('EPA# is Required. If none exists, enter N/A');
    if (key === 'rei' && data[key] === '') return error('REI is Required. If none exists, enter 0');
    if (key === 'preHarvestInterval' && data[key] === '') return error('Pre-Harvest Interval is Required. If none exists, enter 0');
  }
  let formData = new FormData();

  if (document.getElementById('chemical-sds').files.length > 0) {
    let sds = document.getElementById('chemical-sds').files[0];
    formData.append('chemical-sds', sds, sds.name);
  }
  if (document.getElementById('chemical-label').files.length > 0) {
    let label = document.getElementById('chemical-label').files[0];
    formData.append('chemical-label', label, label.name);
  }
  if (document.getElementById('chemical-supplementalLabel').files.length > 0) {
    let suppLabel = document.getElementById('chemical-supplementalLabel').files[0];
    formData.append('chemical-supplementalLabel', suppLabel, suppLabel.name);
  }
  if (document.getElementById('chemical-specialLocalNeedsLabel').files.length > 0) {
    let slnLabel = document.getElementById('chemical-specialLocalNeedsLabel').files[0];
    formData.append('chemical-specialLocalNeedsLabel', slnLabel, slnLabel.name);
  }

  formData.append('editedBy', eid);

  for (let key in data) formData.append(key, data[key]);
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/${path}`, formData, {
      params: { editedChemical },
      headers: { 'content-type': 'multipart/form-data' }
    }).then((res) => {
      $('#preloader').css('display','none');
      resetForm('chemical-form');
      success(res.data.msg);
      dispatch({ type, payload: res.data.c });
    }).catch((err) => {
      $('#preloader').css('display','none');
      dispatch({type: 'ERROR', payload: err});
    });
  }
}
/**
* emailFile(): Emails a file
* @param {String} filename: Name of the file to download
* @returns {Object} blob: Actual file
* @called-in: ['/components/chemical/chemical_view->product_view.js']
**/
export function sendFile(filename, email) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/sendFile`, {
      params: { filename, email },
      headers: {
        authorization: localStorage.getItem('token')
      }
    }).then((res) => {
      $('#preloader').css('display','none');
      success(res.data.msg);
      dispatch({ type: EMAIL_FILE });
    }).catch((err) => {
      $('#preloader').css('display','none');
      dispatch(error(`There was an error emailing a file.`));
    });
  }
}
/**
* selectChemical(): Selects a chemical to view
* @param {Number} id: id of chemical
* @returns {Object} type, payload
* @called-in: ['/components/chemical/chemical_view']
**/
export function selectChemical(c) {
  return {
    type: SELECT_CHEMICAL,
    payload: c.id
  }
}
/**
* selectChemicalToEdit(): Selects a chemical to edit
* @param {Number} id: id of chemical
* @returns {Object} type, payload
* @called-in: ['/components/chemical/chemical_view']
* @notes: Select form value will not set without setTimeout
**/
export function selectChemicalToEdit(c) {
  setTimeout(() => {
    fillForm('chemical-form', c);
    handleRecommendedDosage(c.recoDosage);
    handleMaxQuantity(c.maxQuantity);
  }, 200);
  return {
    type: SELECT_CHEMICAL_TO_EDIT,
    payload: c.id
  }
}
/**
* clearForm(): Clears a form; resets state
* @param {Number} id: id of form
* @returns {Object} type, payload
* @called-in: ['/components/chemical/chemical_view']
**/
export function clearForm(formid) {
  document.getElementById(formid).reset();
  return {
    type: CLEAR_FORM
  }
}
export function error(err) {
  Materialize.toast(err, 4000, 'rounded red');
  return {
    type: ERROR,
    err
  };
}
export function success(msg) {
  Materialize.toast(msg, 4000, 'rounded green');
}



































/* END */



// WEBPACK FOOTER //
// ./src/cultivation/actions/chem_actions.js